// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3nRdj","header":"ClearentDisclaimer_header__2xWqP","inner":"ClearentDisclaimer_inner__Fbt_m"};